var _g, _rect, _rect2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgChamfer = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_579_112065)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4.64355,
    y: 12.5,
    width: 34,
    height: 14,
    stroke: "#737478",
    strokeDasharray: "5 5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5801 1.97656L50.0925 21.489L41.6556 29.9259L22.1432 10.4135L30.5801 1.97656Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1895 9.36719L42.7019 28.8796L40.9902 30.5913L21.4778 11.0789L23.1895 9.36719Z",
    fill: "#F87B0E"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.64355,
    y: 23.5,
    width: 5,
    height: 5,
    fill: "white",
    stroke: "#2C3038"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.64355,
    y: 10.5,
    width: 5,
    height: 5,
    fill: "white",
    stroke: "#2C3038"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_579_112065"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 15,
    fill: "white",
    transform: "translate(2.14355 12)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgChamfer);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/chamfer.aa947dedd76f4cbba62d32ed257dcaf1.svg";